import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { usePendingTransactions } from "@hooks/transfers/usePendingTransactions";
import { i18n, Translations } from "@i18n";
import { TransactionList } from "@routes/TransfersRoute/TransactionList";

export const PendingTransfers = () => {
  const { data, loading, error } = usePendingTransactions();

  if (loading) return null;

  if (error) {
    return (
      <>
        <Spacing size={SpacingSizes.M} />
        <Body>{i18n.t(Translations.GenericErrorMessage)}</Body>
      </>
    );
  }

  if (data.length === 0) {
    return (
      <>
        <Spacing size={SpacingSizes.M} />
        <Body>{i18n.t(Translations.TransfersRoutePendingNoTransfers)}</Body>
      </>
    );
  }

  return <TransactionList data={data} />;
};
